"use client"

import { usePathname, useRouter } from "next/navigation"

import { Select } from "~/components/ui/Select"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import type { LegalsSidebarProps } from "~/app/[locale]/legals/[slug]/_components/LegalsSidebar"

import { hideFrom } from "~/styles/utils/show-hide"

type SelectClientProps = { links: LegalsSidebarProps["links"] }

export function SelectClient({ links }: SelectClientProps) {
  const t = useTranslate()
  const router = useRouter()
  const pathname = usePathname()

  const selectedOptionIndex = links.findIndex((link) => link.href === pathname)

  return (
    <Select
      className={hideFrom("tablet", "block")}
      name={t("aria_legals_select")}
      id={"legals-select"}
      onChange={(e) => router.push(e.target.value)}
    >
      {{
        options: links.map((link, i) => (
          <option value={link.href} key={`legals-option-${i}`} selected={i === selectedOptionIndex}>
            {link.children}
          </option>
        )),
      }}
    </Select>
  )
}
